import {ACTIONS} from "../reducers/flashReducer";

export function setFlash(flash) {
  return {type: ACTIONS.SET_FLASH, flash};
}

export function clearFlash() {
  return {type: ACTIONS.CLEAR_FLASH};
}
